import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { CiiuModel, EmployedContractModel, FinancialModel, OfficeModel, OtherFinancialModel, TypeContractModel, } from 'src/app/shared/models/abre-cuentas.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { StringHelperService } from 'src/app/shared/services/helpers/string-helper.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { ValidationHelperService } from '../../../shared/services/helpers/validation-helper.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { ERROR_LIB } from 'src/app/shared/constants/abre-cuentas.constants';
var ClientDataUpdateComponent = /** @class */ (function () {
    function ClientDataUpdateComponent(headerService, copyService, parametersService, abreCuentasService, formBuilder, stringHelperService, helperService, validationHelperService, navigationService, captureService, bitacoraService, cdr, productLoaderService, firmlyApprovedService, channelCommunicatorService, formatNumber, requestService) {
        this.headerService = headerService;
        this.copyService = copyService;
        this.parametersService = parametersService;
        this.abreCuentasService = abreCuentasService;
        this.formBuilder = formBuilder;
        this.stringHelperService = stringHelperService;
        this.helperService = helperService;
        this.validationHelperService = validationHelperService;
        this.navigationService = navigationService;
        this.captureService = captureService;
        this.bitacoraService = bitacoraService;
        this.cdr = cdr;
        this.productLoaderService = productLoaderService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.formatNumber = formatNumber;
        this.requestService = requestService;
        this.typeContracts = [];
        this.confirmData = false;
        this.isDisabledCity = true;
        this.isDisabledCityWork = true;
        this.closeLoading = false;
        this.loanNormalization = false;
        this.config = {
            allowNegative: false,
            decimal: ',',
            precision: 0,
            thousands: '.',
            prefix: '$ ',
        };
        this.enableDetail = false;
        this.headerService.show(true, true, true);
        this.formGroup = this.formBuilder.group({});
        this.personalData = true;
        this.laboralData = true;
        this.financialData = true;
        this.showOtherIncomes = false;
        this.ciiu_show = true;
        this.contract_show = true;
        this.company_show = true;
        this.city_work_show = true;
        this.address_work_show = true;
        this.phone_work_show = true;
        this.backLabel = false;
        this.date_button = false;
        this.other_btn_show = true;
        // this.stateDateContract = false;
        this.getDistrict();
    }
    ClientDataUpdateComponent.prototype.ngOnInit = function () {
        var e_1, _a;
        var _this = this;
        this.navigationService.pageLoadTag(false, ['pv434', '', '', '']);
        this.bitacoraService.saveDataInBitacora('Int_client_data_update');
        this.chanelid = CHANNEL.PORTALO.CODE;
        this.flagOperador = this.channelCommunicatorService.getChannelId() === this.chanelid;
        // const formatNumber = new FormatNumberService();
        this.formGroup = new FormGroup({
            districtValue: new FormControl('', [Validators.required]),
            cityResidence: new FormControl('', [Validators.required]),
            addressResidence: new FormControl('', [
                Validators.required, Validators.minLength(4),
                Validators.maxLength(40), Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/)),
            ]),
            livingPlace: new FormControl('', [Validators.required]),
            stratum: new FormControl('', [Validators.required]),
            civilStatus: new FormControl('', [Validators.required]),
            emailAddress: new FormControl({ value: '', disabled: this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALO.CODE ? false : true }),
            phoneContact: new FormControl({ value: '', disabled: this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALO.CODE ? false : true }),
            company: new FormControl(''),
            ciiu: new FormControl(''),
            ciiuGeneral: new FormControl(''),
            contract: new FormControl(''),
            districtWorkValue: new FormControl(''),
            cityWorking: new FormControl(''),
            addressWork: new FormControl(''),
            phoneCompany: new FormControl(''),
            origin: new FormControl('', [Validators.required]),
            income: new FormControl('', [Validators.required, Validators.min(10000)]),
            originOtherIncome: new FormControl(''),
            OtherIncomes: new FormControl(''),
            Expenses: new FormControl('', [Validators.required]),
            Debts: new FormControl('', [Validators.required]),
            Goods: new FormControl('', [Validators.required]),
        });
        this.formControls = this.formGroup.controls;
        this.maximumDate = new Date('dd/mm/yyyy');
        this.employedModel = this.abreCuentasService.getEmployedContractModel();
        this.selectedDate = this.employedModel.contractDate;
        this.occupationSelected = this.abreCuentasService.getOccupationSelected();
        switch (this.occupationSelected.name) {
            case 'Pensionado':
                this.formControls.ciiu.setValidators([Validators.nullValidator]);
                this.formControls.ciiuGeneral.setValidators([Validators.nullValidator]);
                this.formControls.company.setValidators([Validators.nullValidator]);
                this.formControls.contract.setValidators([Validators.nullValidator]);
                this.formControls.districtWorkValue.setValidators([Validators.nullValidator]);
                this.formControls.cityWorking.setValidators([Validators.nullValidator]);
                this.formControls.addressWork.setValidators([Validators.nullValidator]);
                this.formControls.phoneCompany.setValidators([Validators.nullValidator]);
                this.laboralData = false;
                this.date_button = true;
                break;
            case 'Estudiante':
                this.formControls.ciiu.setValidators([Validators.nullValidator]);
                this.formControls.ciiuGeneral.setValidators([Validators.nullValidator]);
                this.formControls.company.setValidators([Validators.nullValidator]);
                this.formControls.contract.setValidators([Validators.nullValidator]);
                this.formControls.districtWorkValue.setValidators([Validators.nullValidator]);
                this.formControls.cityWorking.setValidators([Validators.nullValidator]);
                this.formControls.addressWork.setValidators([Validators.nullValidator]);
                this.formControls.phoneCompany.setValidators([Validators.nullValidator]);
                this.laboralData = false;
                this.date_button = true;
                break;
            case 'Hogar':
                this.formControls.ciiu.setValidators([Validators.nullValidator]);
                this.formControls.ciiuGeneral.setValidators([Validators.nullValidator]);
                this.formControls.company.setValidators([Validators.nullValidator]);
                this.formControls.contract.setValidators([Validators.nullValidator]);
                this.formControls.districtWorkValue.setValidators([Validators.nullValidator]);
                this.formControls.cityWorking.setValidators([Validators.nullValidator]);
                this.formControls.addressWork.setValidators([Validators.nullValidator]);
                this.formControls.phoneCompany.setValidators([Validators.nullValidator]);
                this.laboralData = false;
                this.date_button = true;
                break;
            case 'Empleado':
                this.formControls.ciiu.setValidators([Validators.nullValidator]);
                this.formControls.ciiuGeneral.setValidators([Validators.nullValidator]);
                this.formControls.company.setValidators([Validators.required]);
                this.formControls.contract.setValidators([Validators.required]);
                this.formControls.districtWorkValue.setValidators([Validators.required]);
                this.formControls.cityWorking.setValidators([Validators.required]);
                this.formControls.addressWork.setValidators([
                    Validators.required, Validators.minLength(4), Validators.maxLength(40),
                    Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/)),
                ]);
                this.formControls.phoneCompany.setValidators([Validators.required, Validators.pattern(/^([1-9]{1,1}[0-9]{6,9})$/)]);
                this.ciiu_show = false;
                this.date_button = this.selectedDate ? true : false;
                break;
            case 'Independiente':
                this.formControls.contract.setValidators([Validators.nullValidator]);
                this.formControls.ciiuGeneral.setValidators([Validators.required]);
                this.formControls.ciiu.setValidators([Validators.required]);
                this.formControls.company.setValidators([Validators.required]);
                this.formControls.districtWorkValue.setValidators([Validators.required]);
                this.formControls.cityWorking.setValidators([Validators.required]);
                this.formControls.addressWork.setValidators([
                    Validators.required, Validators.minLength(4), Validators.maxLength(40),
                    Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/)),
                ]);
                this.formControls.phoneCompany.setValidators([Validators.required, Validators.pattern(/^([1-9]{1,1}[0-9]{6,9})$/)]);
                this.contract_show = false;
                this.ciiuSelected = this.abreCuentasService.getCiiuSelected();
                this.selectedDate = this.abreCuentasService.getCiiuDate();
                this.date_button = this.selectedDate ? true : false;
                break;
            default:
                this.formControls.contract.setValidators([Validators.nullValidator]);
                this.formControls.ciiu.setValidators([Validators.required]);
                this.formControls.ciiuGeneral.setValidators([Validators.required]);
                this.formControls.company.setValidators([Validators.required]);
                this.formControls.districtWorkValue.setValidators([Validators.required]);
                this.formControls.cityWorking.setValidators([Validators.required]);
                this.formControls.addressWork.setValidators([
                    Validators.required, Validators.minLength(4), Validators.maxLength(40),
                    Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/)),
                ]);
                this.formControls.phoneCompany.setValidators([Validators.required, Validators.pattern(/^([1-9]{1,1}[0-9]{6,9})$/)]);
                this.contract_show = false;
                this.ciiuSelected = this.abreCuentasService.getCiiuSelected();
                this.selectedDate = this.abreCuentasService.getCiiuDate();
                console.log('this.selectedDate............', this.selectedDate);
                this.date_button = this.selectedDate ? true : false;
                break;
        }
        this.product_type = this.abreCuentasService.getproductSelected().product_type;
        this.city_option = this.parametersService.getSetting(OpEnum.CITY_LIST);
        this.living_option = this.parametersService.getSetting(OpEnum.HOUSING_TYPE);
        this.stratum_option = this.parametersService.getSetting(OpEnum.STRATUM);
        this.civil_status_options = this.parametersService.getSetting(OpEnum.CIVIL_STATUS_LIST);
        var occupationTime = this.parametersService.getSetting(OpEnum.OCUPATION_TIME_TC);
        this.contract_option = occupationTime ? occupationTime['list_dependent_time'] :
            this.abreCuentasService.getListTypeContract();
        if (this.abreCuentasService.getFlowLoan() && this.abreCuentasService.getOccupationSelected().id === 1) {
            this.contract_option = this.parametersService.getSetting(OpEnum.LIST_TYPE_CONTRACT_LOAN);
        }
        this.independent_option = this.occupationSelected.id === 2 ? occupationTime['independent_time'] : 0;
        this.origin_options = this.parametersService.getSetting(OpEnum.SOURCE_OF_FUNDS);
        this.optionsCiiu = this.parametersService.getSetting(OpEnum.CIIU_GENERAL_LIST);
        this.ciiu_options = this.parametersService.getSetting(OpEnum.CIIU_LIST);
        this.optionsFilter = this.ciiu_options;
        var user_info = this.abreCuentasService.getContactInfo();
        this.dataClient = this.abreCuentasService.getCustomerData();
        this.ciiuInfo = this.ciiu_options.filter(function (activity) { return activity.ciiu === _this.dataClient.basic.professional_activity
            .find(function (item) { return item.key === 'sic'; })
            .name.toString()
            .replace(/^(\d{1})$/g, '00$1')
            .replace(/^(\d{2})$/g, '0$1'); })[0];
        user_info.address.address = user_info.address.address.trim() == '' ? this.dataClient.address.addresses.filter(function (e) { return (e.type == '1'); })[0].street.trim() : user_info.address.address.trim();
        var districtResidense = this.dataClient.basic.addresses.district;
        if (districtResidense === null || districtResidense === undefined) {
            districtResidense = '';
        }
        this.officeInfo = this.abreCuentasService.getOfficeInfo(this.occupationSelected.id);
        var addressOffice = this.dataClient.address.addresses.filter(function (e) { return (e.type === '2') || (e.type === '3') ||
            (e.type === '11') || (e.type === '5'); });
        var flag_type = false;
        try {
            for (var addressOffice_1 = tslib_1.__values(addressOffice), addressOffice_1_1 = addressOffice_1.next(); !addressOffice_1_1.done; addressOffice_1_1 = addressOffice_1.next()) {
                var iterator = addressOffice_1_1.value;
                if (iterator.type === '5') {
                    flag_type = true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (addressOffice_1_1 && !addressOffice_1_1.done && (_a = addressOffice_1.return)) _a.call(addressOffice_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        addressOffice = flag_type ? addressOffice.find(function (e) { return (e.type === '5'); }) : addressOffice.find(function (e) { return (e.type === '3') ||
            (e.type === '11') || (e.type === '2'); });
        if (addressOffice === undefined || addressOffice === null) {
            addressOffice = '';
        }
        var mobilePhoneOffice = this.dataClient.contact.phones.find(function (e) {
            var code = e.phone_type.split('-')[0];
            if (code === '5' || code === '2' || code === '11') {
                return e;
            }
        });
        this.phoneCompany = mobilePhoneOffice;
        if (mobilePhoneOffice === null || mobilePhoneOffice === undefined) {
            mobilePhoneOffice = '';
        }
        this.addressWork = addressOffice;
        this.selecteCityWork = this.city_option.filter(function (ei) {
            return (ei.city_code === addressOffice.city) && (ei.province_code === parseInt(addressOffice.district, 10));
        });
        if (addressOffice.city === '997') {
            this.selecteCityWork = '';
        }
        if (this.selecteCityWork === undefined || this.selecteCityWork === null) {
            this.selecteCityWork = '';
        }
        if (this.selecteCityWork.length > 0) {
            this.selecteCityWork[0].description = this.selecteCityWork[0].description.toUpperCase();
        }
        var basicData = this.dataClient.basic;
        var aditionalInformation = basicData.additional_information.filter(function (element) {
            return element.key === 'Total Ingresos';
        });
        var aditional = 0;
        var aditionalInfo = aditionalInformation.forEach(function (element) {
            aditional = parseInt(element.name.replace(/[$,]/g, ''), 10);
            console.log(aditionalInfo);
        });
        this.setCiiuGeneralOptions();
        this.formControls.ciiu.setValue(this.ciiuInfo);
        this.formControls.addressResidence.setValue(user_info.address.address);
        this.flagOperador ? this.formControls.emailAddress.setValue(user_info.email) : this.formControls.emailAddress.setValue(this.validationHelperService.maskMail(user_info.email));
        this.flagOperador ? this.formControls.phoneContact.setValue(user_info.mobile_number) : this.formControls.phoneContact.setValue(this.validationHelperService.maskPhone(user_info.mobile_number));
        this.formControls.company.setValue(this.officeInfo.company_name);
        this.formControls.addressWork.setValue(this.officeInfo.address.addressInput);
        this.formControls.phoneCompany.setValue(this.officeInfo.office_number);
        this.selectedCityResidence = user_info.address.city;
        this.selectedLivingResidence = user_info.address.housingType ? user_info.address.housingType.description : null;
        this.selectedLivingResidence = this.selectedLivingResidence ?
            this.helperService.validateDiacritialMask(this.selectedLivingResidence) : '';
        this.selectedStratum = user_info.address.stratum;
        this.selectedCivilStatus = this.abreCuentasService.getMaritalStatusInfo() ? this.helperService.validateDiacritialMask(this.abreCuentasService.getMaritalStatusInfo().marital_status_description) : '';
        this.addressResidence = user_info.address.address;
        this.flagOperador ? this.emailAddress = user_info.email : this.emailAddress = this.validationHelperService.maskMail(user_info.email);
        this.flagOperador ? this.phoneContact = user_info.mobile_number : this.phoneContact = this.validationHelperService.maskPhone(user_info.mobile_number);
        if (this.selectedDate !== '') {
            this.selectedDate = new Date(this.selectedDate.replace(/^(\d{2})\/(\d{2})\/(\d{4})$/g, '$2/$1/$3'));
            this.selectedDate = this.helperService.formatingVclDate(this.selectedDate);
            this.date = this.selectedDate;
        }
        var financial = this.abreCuentasService.getFinancialInfo();
        var otherFinancial = this.abreCuentasService.getOtherFinancialInfo();
        this.showOtherIncomes = otherFinancial.otherIncomes !== 0 ? true : false;
        this.incomesSourceSelection = this.showOtherIncomes ? 'si' : 'no';
        this.radioIncome = [{
                label: this.copyService.copies.client_data_update.financial.other_income.si,
                elementId: 1,
                checked: this.showOtherIncomes,
                value: 'si',
            },
            {
                label: this.copyService.copies.client_data_update.financial.other_income.no,
                elementId: 2,
                checked: !this.showOtherIncomes,
                value: 'no',
            }];
        /* this.selectOtherOriginIncome = otherFinancial.otherFunds; */
        // tslint:disable-next-line:early-exit
        if (Object.keys(financial).length > 0) {
            financial.origin = this.abreCuentasService.getIncomesOriginSearchSelected().value;
            this.selectOriginIncome = financial.origin,
                // this.formControls.income.setValue(financial.incomes);
                this.formControls.income.setValue(aditional);
            this.formControls.Expenses.setValue(financial.expenses);
            this.formControls.Debts.setValue(financial.debt);
            this.formControls.Goods.setValue(financial.goods);
            // this.income = financial.incomes;
            this.income = aditional;
            this.valueExpenses = financial.expenses;
            this.valueDebts = financial.debt;
            this.valueGoods = financial.goods;
        }
        this.selectOtherOriginIncome = otherFinancial.otherFunds;
        this.valueOtherIncomes = otherFinancial.otherIncomes;
        this.formControls.OtherIncomes.setValue(otherFinancial.otherIncomes);
    };
    ClientDataUpdateComponent.prototype.ngAfterViewInit = function () {
        this.cdr.detectChanges();
    };
    ClientDataUpdateComponent.prototype.isSelectIncome = function (e) {
        this.incomesSourceSelection = e.target.value;
        if (e.target.value === 'si') {
            this.showOtherIncomes = true;
            this.reactiveOtherIncomes();
        }
        else {
            this.other_btn_show = true;
            this.formControls.OtherIncomes.setValue('');
            this.showOtherIncomes = false;
        }
    };
    ClientDataUpdateComponent.prototype.reactiveOtherIncomes = function () {
        if (this.formControls.originOtherIncome.value !== '' && this.formControls.OtherIncomes.value !== '') {
            this.other_btn_show = true;
        }
        else {
            this.other_btn_show = false;
        }
    };
    ClientDataUpdateComponent.prototype.selectOptionCiiu = function (ciiuSelected) {
        if (ciiuSelected.value) {
            this.calculateCiiuOptions(ciiuSelected.value);
            this.enableDetail = true;
        }
        else {
            this.formControls.ciiu.setValue('');
            this.enableDetail = false;
        }
    };
    ClientDataUpdateComponent.prototype.setCiiuGeneralOptions = function () {
        if (this.ciiu_show && this.laboralData) {
            var ciiu = this.ciiuSelected.ciiu.length === 3 ? '0' + this.ciiuSelected.ciiu : this.ciiuSelected.ciiu;
            var ciiuCode_1 = ciiu.substring(0, 2);
            this.selectedGeneral = {
                ciiu: ciiuCode_1,
                description: this.optionsCiiu.filter(function (option) { return option.ciiu === ciiuCode_1; })[0].description,
            };
            this.calculateCiiuOptions(ciiuCode_1);
            this.formControls.ciiuGeneral.setValue(this.selectedGeneral.ciiu);
            this.enableDetail = true;
        }
    };
    ClientDataUpdateComponent.prototype.calculateCiiuOptions = function (value) {
        this.ciiu_options = this.optionsFilter.filter(function (option) {
            var ciiuSelect = option.ciiu.length === 3 ? '0' + option.ciiu : option.ciiu;
            return ciiuSelect.substring(0, 2) == value;
        });
    };
    ClientDataUpdateComponent.prototype.reactiveCiiu = function (e) {
        if (e.value.ciiu !== '090') {
            this.company_show = true;
            this.city_work_show = true;
            this.address_work_show = true;
            this.phone_work_show = true;
            this.formControls.company.setValidators([Validators.required]);
            this.formControls.districtWorkValue.setValidators([Validators.required]);
            this.formControls.cityWorking.setValidators([Validators.required]);
            this.formControls.addressWork.setValidators([
                Validators.required, Validators.minLength(4), Validators.maxLength(40),
                Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/)),
            ]);
            this.formControls.phoneCompany.setValidators([Validators.required, Validators.pattern(/^([1-9]{1,1}[0-9]{6,9})$/)]);
        }
        else {
            this.formControls['company'].setValidators([]); // or clearValidators()
            this.formControls['company'].updateValueAndValidity();
            this.formControls['districtWorkValue'].setValidators([]); // or clearValidators()
            this.formControls['districtWorkValue'].updateValueAndValidity();
            this.formControls['cityWorking'].setValidators([]); // or clearValidators()
            this.formControls['cityWorking'].updateValueAndValidity();
            this.formControls['addressWork'].setValidators([]); // or clearValidators()
            this.formControls['addressWork'].updateValueAndValidity();
            this.formControls['phoneCompany'].setValidators([]); // or clearValidators()
            this.formControls['phoneCompany'].updateValueAndValidity();
            this.company_show = false;
            this.city_work_show = false;
            this.address_work_show = false;
            this.phone_work_show = false;
        }
    };
    ClientDataUpdateComponent.prototype.inputPhone = function ($event) {
        var value = $event.target.value;
        var phone = this.getNumberFormat(value);
        $event.target.value = phone.clearValue;
    };
    ClientDataUpdateComponent.prototype.outPhone = function ($event) {
        var value = $event.target.value;
        var phone = this.getNumberFormat(value);
        $event.target.value = phone.format;
    };
    ClientDataUpdateComponent.prototype.getNumberFormat = function (value) {
        // const formatNumber = new FormatNumberService();
        return this.formatNumber.formatNumberPhone(value);
    };
    ClientDataUpdateComponent.prototype.reactiveDatePicker = function (e) {
        this.date_button = e.target.value !== '' ? true : false;
        this.date = e.target.value;
    };
    ClientDataUpdateComponent.prototype.reactiveInputChangePhoneWork = function () {
        var controlPhone = this.formControls.phoneCompany;
        controlPhone.setValue(controlPhone.value.slice(0, 10));
        controlPhone.setValue(controlPhone.value.replace(new RegExp(/[^\d]/), ''));
    };
    ClientDataUpdateComponent.prototype.back = function () {
        this.confirmData = false;
        this.backLabel = false;
        this.helperService.scrollToTop();
    };
    ClientDataUpdateComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var a, maritialValue, maritialStatus, e_2, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        a = this.formControls.OtherIncomes.value;
                        maritialValue = this.formControls.civilStatus.value;
                        if (!this.confirmData) {
                            this.bitacoraService.saveDataInBitacora('confirm_client_data_update');
                            this.backLabel = 'Editar';
                            this.confirmData = true;
                            maritialStatus = {
                                marital_status_code: maritialValue.id,
                                marital_status_description: maritialValue.value,
                            };
                            this.helperService.scrollToTop();
                            this.setUserContactInfo();
                            this.abreCuentasService.setMaritalStatusInfo(maritialStatus);
                            if (this.occupationSelected.name !== 'Pensionado') {
                                this.setUserOfficeinfo();
                            }
                            this.setUserWorkInfo();
                            this.setUserFinancialInfo();
                            this.setUserOtherFinancialInfo();
                            return [2 /*return*/];
                        }
                        this.other_btn_show = false;
                        this.bitacoraService.saveDataInBitacora('Ini_send_client_data_update');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        // if (!this.stateDateContract) {
                        return [4 /*yield*/, this.captureService.createContactInfo()];
                    case 2:
                        // if (!this.stateDateContract) {
                        _a.sent();
                        return [4 /*yield*/, this.captureService.prospectAddresses()];
                    case 3:
                        _a.sent();
                        if (!(this.occupationSelected.name !== 'Pensionado')) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.captureService.prospectAddresses('LABORAL')];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [4 /*yield*/, this.captureService.createFinancials()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, this.callIncomeLoan()];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        e_2 = _a.sent();
                        this.handleError();
                        return [3 /*break*/, 9];
                    case 9:
                        if (!((this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
                            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
                            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN ||
                            this.product_type === BUSINESS_CONST.MULTI) &&
                            (this.firmlyApprovedService.isEmpty() &&
                                this.firmlyApprovedService.getOfferType_Channel() !== 'En_firme'))) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.getPcoAmount()];
                    case 10:
                        _a.sent();
                        if (!this.pcoAmountValidation) {
                            this.productLoaderService.hide();
                            return [2 /*return*/];
                        }
                        _a.label = 11;
                    case 11:
                        _a.trys.push([11, 15, , 16]);
                        // if (!this.stateDateContract) {
                        return [4 /*yield*/, this.captureService.createFinancials()];
                    case 12:
                        // if (!this.stateDateContract) {
                        _a.sent();
                        if (!((this.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
                            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL ||
                            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
                            this.product_type === BUSINESS_CONST.MULTI)
                            && !this.firmlyApprovedService.isFirmlyApproved())) return [3 /*break*/, 14];
                        if (!((this.product_type !== BUSINESS_CONST.PRODUCT_TYPE_SAVINGS
                            || this.product_type !== BUSINESS_CONST.PRODUCT_TYPE_PAYROLL)
                            && this.channelCommunicatorService.getChannelId() !== CHANNEL.PORTALO.CODE)) return [3 /*break*/, 14];
                        return [4 /*yield*/, this.captureService.createClient()];
                    case 13:
                        _a.sent();
                        _a.label = 14;
                    case 14:
                        this.bitacoraService.saveDataInBitacora('Out_send_client_data_update');
                        this.advance();
                        return [3 /*break*/, 16];
                    case 15:
                        e_3 = _a.sent();
                        this.handleError();
                        return [3 /*break*/, 16];
                    case 16: return [2 /*return*/];
                }
            });
        });
    };
    ClientDataUpdateComponent.prototype.callIncomeLoan = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.abreCuentasService.haveLoan || this.product_type === BUSINESS_CONST.MULTI)) return [3 /*break*/, 2];
                        this.bitacoraService.saveDataInBitacora('Ini_loading_Incomes');
                        return [4 /*yield*/, this.captureService.performIncomes().then(function (res) {
                                if (res === 200) {
                                    _this.bitacoraService.saveDataInBitacora('Out_loading_Incomes');
                                }
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ClientDataUpdateComponent.prototype.advance = function () {
        var bitacoraEvent = "client_update_confirm";
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        this.abreCuentasService.hideGenericLoading();
        if (this.abreCuentasService.isGrayZone() && (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
            this.product_type === BUSINESS_CONST.MULTI)) {
            this.navigationService.nextStep('202');
            this.checkLoading();
            return;
        }
        // if (this.product_type === BUSINESS_CONST.MULTI) {
        //   let arrProductMulti = this.abreCuentasService.getProductsSelects();
        //   let strNextStop = '201';
        //   if (arrProductMulti.filter(product => product.flow === BUSINESS_CONST.PRODUCT_TYPE_FREE).length > 0) {
        //     strNextStop = '200';
        //   }
        //   this.navigationService.nextStep(strNextStop);
        // }
        if (!this.loanNormalization) {
            this.navigationService.nextStep('200');
        }
        this.checkLoading();
    };
    ClientDataUpdateComponent.prototype.handleError = function () {
        this.abreCuentasService.hideGenericLoading();
        this.navigationService.navigateToGeneralInformation('500');
    };
    ClientDataUpdateComponent.prototype.checkLoading = function () {
        if (this.closeLoading) {
            this.productLoaderService.hide();
        }
    };
    // validateDateContract() {
    //   const actualDate = new Date();
    //   this.timeText = this.occupationSelected.id === 1 ? this.formControls.contract.value.timeText : this.independent_option.timeText;
    //   const timeMin = this.occupationSelected.id === 1 ? this.formControls.contract.value.timeMin : this.independent_option.timeMin;
    //   actualDate.setMonth(actualDate.getMonth() - timeMin);
    //   const contract_date = new Date(this.selectedDate.replace(/^(\d{2})\/(\d{2})\/(\d{4})$/g, '$2/$1/$3'));
    //   if (contract_date > actualDate) {
    //     return true;
    //   }
    //   return false;
    // }
    ClientDataUpdateComponent.prototype.getPcoAmount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.productLoaderService.show(this.copyService.copies.show_load_pco, this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
                        this.bitacoraService.saveDataInBitacora('Ini_loading_PCO');
                        return [4 /*yield*/, this.captureService.performPco().then(function (result) {
                                if (result !== '200') {
                                    _this.navigationService.navigateToGeneralInformation('127');
                                    return;
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO'])];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.captureService.getChannelComunicator(false, true).then(function (result2) {
                                _this.pcoAmountValidation = true;
                                if (result2 === '107' || result2 === '121' || result2 === '130' || result2 === '129' || result2 === '124' || result2 === '127') {
                                    // if (result2 === '129') {
                                    //   this.navigationService.pageLoadTag('ErrorProcesoEnTramite', ['pv426', '', 'pv572', '']);
                                    // }
                                    if (result2 === '121') {
                                        _this.navigationService.pageLoadTag('ErrorSolicitudNoAprobada', ['pv438', '', '', '']);
                                    }
                                    _this.navigationService.navigateToGeneralInformation(result2);
                                    _this.pcoAmountValidation = false;
                                }
                                if (result2 === '17') {
                                    _this.loanNormalization = true;
                                    _this.navigationService.navigateToGeneralInformation(ERROR_LIB.CODE);
                                    _this.bitacoraService.saveDataInBitacora('Normalization_yes');
                                }
                                else {
                                    _this.bitacoraService.saveDataInBitacora('Out_loading_PCO');
                                    _this.closeLoading = true;
                                }
                            }).catch(function () { return _this.navigationService.navigateToGeneralInformation('107'); })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ClientDataUpdateComponent.prototype.setUserContactInfo = function () {
        var contactCity = {
            city_code: this.formControls.cityResidence.value.code_dane.slice(-3),
            country_code: this.formControls.cityResidence.value.code_dane.slice(-3),
            province_code: this.formControls.cityResidence.value.code_dane.slice(0, -3),
            description: this.formControls.cityResidence.value.city + ", " + this.formControls.cityResidence.value.district.district,
            bp_city_code: this.formControls.cityResidence.value.code_dane.slice(-3),
            bp_province_code: this.formControls.cityResidence.value.code_dane.slice(0, -3),
            district_id: this.formControls.cityResidence.value.district.district_id,
        };
        var user_info = this.abreCuentasService.getContactInfo();
        var contactInfo = {
            mobile_number: this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALO.CODE ? this.formControls.phoneContact.value : user_info.mobile_number,
            email: this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALO.CODE ? this.formControls.emailAddress.value : user_info.email,
            employment_number: this.formControls.phoneCompany.value,
            address: {
                city: contactCity,
                addressInput: this.formControls.addressResidence.value,
                detail: user_info.address.detail ? user_info.address.detail : '',
                address: this.validateAddress('addressResidence'),
                stratum: this.formControls.stratum.value.id,
                housingType: {
                    housingId: this.formControls.livingPlace.value.id,
                    description: this.formControls.livingPlace.value.name,
                },
            },
        };
        if (this.formControls.ciiu.value) {
            this.selectedCiiu = this.formControls.ciiu.value;
            this.abreCuentasService.setCiiuSelected(this.selectedCiiu);
            this.abreCuentasService.setCiiuDate(this.date);
        }
        this.abreCuentasService.setContactInfo(contactInfo);
    };
    ClientDataUpdateComponent.prototype.setUserOfficeinfo = function () {
        if (this.occupationSelected.name === 'Pensionado') {
            var contactCityWork = {
                city_code: '',
                country_code: '',
                province_code: 5,
                description: '',
            };
            this.officeInfo = {
                occupation_id: this.occupationSelected.id,
                company_name: '',
                company_nameInput: '',
                address: {
                    city: contactCityWork,
                    address: '',
                    detail: '',
                    addressInput: '',
                },
                office_number: '',
            };
        }
        else {
            var contactCityWork = {
                city_code: this.formControls.cityWorking.value.code_dane.slice(-3),
                country_code: this.formControls.cityWorking.value.code_dane.slice(-3),
                province_code: this.formControls.cityWorking.value.code_dane.slice(0, -3),
                description: this.formControls.cityWorking.value.city + ", " + this.formControls.cityWorking.value.district.district,
            };
            this.officeInfo = {
                occupation_id: this.occupationSelected.id,
                company_name: this.validateCompany(),
                company_nameInput: this.formControls.company.value,
                address: {
                    city: contactCityWork,
                    address: this.validateAddress('addressWork'),
                    detail: this.formControls.addressWork.value,
                    addressInput: this.formControls.addressWork.value,
                },
                office_number: this.formControls.phoneCompany.value,
            };
        }
        this.abreCuentasService.setOfficeInfo(this.occupationSelected.id + '', this.officeInfo);
    };
    ClientDataUpdateComponent.prototype.setUserWorkInfo = function () {
        if (!this.contract_show) {
            return;
        }
        this.contract = {
            label: this.formControls.contract.value.label,
            elementId: this.formControls.contract.value.elementId,
            checked: this.formControls.contract.value.checked,
            message: this.formControls.contract.value.message,
            timeText: this.formControls.contract.value.timeText,
            timeMin: this.formControls.contract.value.timeMin,
        };
        var contract = this.typeContracts.find(function (data) { return data.checked; });
        this.employedModel = {
            typeContract: this.contract,
            contractDate: this.date,
        };
        this.abreCuentasService.setEmployedContractModel(this.employedModel);
    };
    ClientDataUpdateComponent.prototype.setUserFinancialInfo = function () {
        this.financialInfo = {
            incomes: +this.formControls.income.value,
            expenses: +this.formControls.Expenses.value,
            debt: +this.formControls.Debts.value,
            goods: +this.formControls.Goods.value,
            origin: this.formControls.origin.value,
            funds: this.formControls.origin.value.value,
            incomes_input: +this.formControls.income.value,
            next: false,
            expensesDiscount: 0,
        };
        this.abreCuentasService.setFinancialInfo(this.financialInfo);
        var financial_origin = {
            id: this.formControls.origin.value.id,
            value: this.formControls.origin.value.value,
        };
        this.abreCuentasService.setIncomesOriginSearchSelected(financial_origin);
    };
    ClientDataUpdateComponent.prototype.setUserOtherFinancialInfo = function () {
        this.otherFinancialInfo = {
            otherIncomes: this.incomesSourceSelection === 'si' ? +this.formControls.OtherIncomes.value : 0,
            otherFunds: this.incomesSourceSelection === 'si' ? this.formControls.originOtherIncome.value.value : '',
            otherOrigin: this.incomesSourceSelection === 'si' ? 1 : 0,
        };
        this.abreCuentasService.setOtherFinancialInfo(this.otherFinancialInfo);
    };
    ClientDataUpdateComponent.prototype.validateAddress = function (value) {
        var controladdress = this.formControls[value];
        return this.stringHelperService.normalizeAddress(controladdress.value, '');
    };
    ClientDataUpdateComponent.prototype.validateCompany = function () {
        var controlCompany = this.formControls['company'];
        return this.stringHelperService.normalizeCompany(controlCompany.value).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };
    ClientDataUpdateComponent.prototype.getDistrict = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestService.districtBrances().then(function (response) {
                            _this.district_option = response.body;
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ClientDataUpdateComponent.prototype.districtSelect = function (event, type) {
        var _this = this;
        if (!event.value) {
            if (type === 'personal') {
                this.formGroup.controls.cityResidence.setValue('');
                this.city_option = {};
                this.isDisabledCity = true;
                return;
            }
            this.formGroup.controls.cityWorking.setValue('');
            this.city_option_work = {};
            this.isDisabledCityWork = true;
            return;
        }
        this.requestService.cityBranches(event.value.district_id)
            .then(function (response) {
            if (type === 'personal') {
                _this.city_option = response.body;
                _this.isDisabledCity = false;
                return;
            }
            _this.city_option_work = response.body;
            _this.isDisabledCityWork = false;
        });
    };
    return ClientDataUpdateComponent;
}());
export { ClientDataUpdateComponent };
